import { render, staticRenderFns } from "./coreProductInfo.vue?vue&type=template&id=10fb0c5f&scoped=true"
import script from "./coreProductInfo.vue?vue&type=script&lang=js"
export * from "./coreProductInfo.vue?vue&type=script&lang=js"
import style0 from "./coreProductInfo.vue?vue&type=style&index=0&id=10fb0c5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fb0c5f",
  null
  
)

export default component.exports